import { memo } from 'react'
import type { CalendarEvent } from '@highlight/common'
import { formatTimeRange, formatTimeUntil } from '../../utils/activity-helpers'

/**
 * A meeting's second line: clock range, then its relative status in a quieter
 * tone — "10:00–10:30am · now". Sits under the title in both the meeting cell
 * and the flat row (Figma `7096:18818`), which is why it lives out here.
 */
export const MeetingTimeLine = memo(function MeetingTimeLine({ meeting }: { meeting: CalendarEvent }) {
  const start = new Date(meeting.start)
  const end = meeting.end ? new Date(meeting.end) : undefined

  return (
    <p className="type-ui-xs truncate font-normal leading-none">
      <span className="text-foreground-secondary">{formatTimeRange(start, end)}</span>{' '}
      <span className="text-foreground-placeholder">· {formatTimeUntil(start, end)}</span>
    </p>
  )
})
